const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/insights/health/$healthInsightId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { RecommendationKind } from '@/features/insights/components/health/insight-details/recommendations/recommendationKind';
import { isHealthSignalInsightId } from '@/features/insights/components/health/shared/types';
import { itemPanelSearchSchema } from '@/features/item-panel/searchSchema';
const paramsSchema = z.object({
  healthInsightId: z.string()
});
const recommendationValues = Object.values(RecommendationKind) as [string, ...string[]];
const healthInsightDetailsSearchSchema = itemPanelSearchSchema.extend({
  recommendation: z.enum(recommendationValues).optional()
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/insights/health/$healthInsightId')({
  params: paramsSchema,
  validateSearch: zodValidator(healthInsightDetailsSearchSchema),
  loader: ({
    params
  }) => {
    if (!isHealthSignalInsightId(params.healthInsightId)) {
      throw redirect({
        to: '/org/$org/loop/$loopId/insights/health',
        params: {
          org: params.org,
          loopId: params.loopId
        }
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});